import { ModalProps } from '@melements/front-components/dist/components/modal/Modal.types';
import { ComponentsModal } from 'shared';
import { FormContent } from 'shared/formContent/FormContent';
import styled, { from, to } from 'theme';

export const ModalDesktopTitle = styled.div`
  display: none;
  font-family: ${p => p.theme.variables.typography.secondaryFont};
  font-size: ${p => p.theme.variables.fonts.size.bigger1};
  font-weight: ${p => p.theme.variables.fonts.weight.bold};
  line-height: 1;
  color: ${p => p.theme.variables.customColors.leadingColor.base};
`;

export const ModalBody = styled(FormContent)`
  padding: 1.5rem 0;
`;

export const ModalWrapper = styled(ComponentsModal as any)<ModalProps & { width?: string }>`
  z-index: 101;

  & + .modal__overlay {
    z-index: 100;
  }

  .modal__title {
    text-transform: none;
  }

  .modal__inner-container {
    border-radius: 0.25rem;
    box-shadow: 0 0 0.5625rem 0 rgba(0, 0, 0, 0.08), 0 1rem 1rem 0 rgba(0, 0, 0, 0.1);
    background-color: white;
    padding: 1rem 1rem 1rem;

    ${to('md')} {
      overflow-y: scroll;
    }
  }

  .modal__close-button {
    top: 1rem;
    right: 1rem;

    .button__icon-wrapper {
      .button__icon {
        background-image: ${p => `url("${p.theme.variables.icons.svg.closeIcon}")`};
      }
    }
  }

  .modal__footer {
    justify-content: flex-end;
  }

  ${p => from(p.breakpoint)} {
    .modal__inner-container {
      padding: 3.75rem 5rem 3rem;
      width: ${p => p.width || 'auto'};
    }

    ${ModalDesktopTitle} {
      display: block;
    }

    ${ModalBody} {
      padding: 3rem;
    }
  }
`;
